// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import useMergeProps from '../../../hooks/useMergeProps';
import {
  selectBasketIsGRActive,
  selectBasketItemsEntityIsGRActive,
  selectBasketItemsEntityStatus,
  selectBasketMode,
  selectBasketStatus,
} from '../../../selectors/basket/basketPrimary.selector';
import { BasketModes, BasketStatuses } from '../../../types/basket';
import GRBetslipEligibleHeadband from '../components/common/GRBetslipEligibleHeadband';

const selectIsVisible = createSelector(
  [
    (_, { oddId }) => oddId,
    selectBasketStatus,
    selectBasketMode,
    selectBasketIsGRActive,
    selectBasketItemsEntityStatus,
    selectBasketItemsEntityIsGRActive,
  ],
  (oddsId, basketStatus, basketMode, basketIsGRActive, basketItemStatus, basketItemIsGRActive) => {
    if (basketMode === BasketModes.SIMPLE && basketStatus === BasketStatuses.VALIDATED) {
      return oddsId && basketItemIsGRActive;
    }

    if (basketMode === BasketModes.COMBINED && basketStatus === BasketStatuses.VALIDATED) {
      return !oddsId && basketIsGRActive;
    }

    return false;
  },
);

type GRBasketBetslipEligibleHeadBandContainerProps = {
  className?: string;
  oddsId?: number;
};

const GRBasketBetslipEligibleHeadBandContainer = ({
  oddsId,
  ...ownProps
}: GRBasketBetslipEligibleHeadBandContainerProps) => {
  const selectorProps = useMemo(() => ({ oddId: oddsId }), [oddsId]);
  const isVisible = useSelector((state) => selectIsVisible(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps });

  return isVisible ? <GRBetslipEligibleHeadband {...enhancedProps} /> : null;
};

export default GRBasketBetslipEligibleHeadBandContainer;
